import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation ApplyBulkTaxProfileTemplate(
    $input: TaxProfileTemplateBulkApplyInput!
  ) {
    applyTaxProfileTemplateBulk(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      bulkApplication {
        id
        actorId
        completedAt
        effectiveAt
        idempotencyKey
        previewDigest
        requestedProductIds
        result
        startedAt
        state
        taxProfileTemplateId
      }
    }
  }
  ${ErrorMessageInfo}
`;
